import React from 'react';
import { Stack, Skeleton } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const EirOfferCardBodySkeleton = () => {
  const theme = useTheme();
  return (
    <Stack sx={{ width: '100%', backgroundColor: theme.palette.primary.contrastText }}>
      <Skeleton
        height={40}
        width='80%'
        sx={{
          marginX: 'auto',
          marginTop: '-0.5rem',
        }}
      />
      <Skeleton
        height={20}
        width='70%'
        sx={{
          marginX: 'auto',
          marginTop: '0.5rem',
        }}
      />
      <Skeleton
        height={20}
        width='60%'
        sx={{
          marginX: 'auto',
          marginTop: '0.2rem',
        }}
      />

      <Stack direction='row' sx={{ marginTop: '2rem', gap: '3%', marginX: '1.5rem' }}>
        <Skeleton variant='circular' width={18} height={18} />
        <Skeleton height='1.2rem' width='85%' />
      </Stack>

      <Stack direction='row' sx={{ marginTop: '0.5rem', gap: '3%', marginX: '1.5rem' }}>
        <Skeleton variant='circular' width={18} height={18} />
        <Skeleton height='1.2rem' width='70%' />
      </Stack>
      <Stack direction='row' sx={{ marginTop: '0.5rem', gap: '3%', marginX: '1.5rem' }}>
        <Skeleton variant='circular' width={18} height={18} />
        <Skeleton height='1.2rem' width='85%' />
      </Stack>
      <Stack direction='row' sx={{ marginTop: '0.5rem', gap: '3%', marginX: '1.5rem' }}>
        <Skeleton variant='circular' width={18} height={18} />
        <Stack direction='column' sx={{ width: '100%' }}>
          <Skeleton height='1.2rem' width='94%' />
          <Skeleton height='1.2rem' width='25%' />
        </Stack>
      </Stack>

      <Skeleton
        variant='reactangular'
        height={40}
        sx={{
          marginX: '1.5rem',
          marginTop: '2rem',
          borderRadius: '2rem',
          mb: '1.5rem',
        }}
      />
    </Stack>
  );
};

export default EirOfferCardBodySkeleton;
